import { useState, useEffect } from "react";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Icon from "@mui/material/Icon";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import TextField from "@mui/material/TextField";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import api from "api/axios";

const defaultForm = {
  nom: "",
  email: "",
  mot_de_passe: "",
  ville: "",
};

function Utilisateurs() {
  const [users, setUsers] = useState([]);
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState(defaultForm);
  const [editId, setEditId] = useState(null);
  const [loading, setLoading] = useState(false);

  const fetchUsers = async () => {
    try {
      const res = await api.get("/users");
      setUsers(res.data);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  const handleOpen = (user = null) => {
    if (user) {
      setForm({ nom: user.nom, email: user.email, ville: user.ville, mot_de_passe: "" });
      setEditId(user.id);
    } else {
      setForm(defaultForm);
      setEditId(null);
    }
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setForm(defaultForm);
    setEditId(null);
  };

  const handleSubmit = async () => {
    setLoading(true);
    try {
      if (editId) {
        await api.put(`/users/${editId}`, form);
      } else {
        await api.post("/users", form);
      }
      fetchUsers();
      handleClose();
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm("Supprimer ce directeur ?")) {
      await api.delete(`/users/${id}`);
      fetchUsers();
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
                display="flex"
                justifyContent="space-between"
                alignItems="center"
              >
                <MDTypography variant="h6" color="white">
                  Directeurs de ville
                </MDTypography>
                <MDButton
                  variant="outlined"
                  color="white"
                  size="small"
                  onClick={() => handleOpen()}
                >
                  <Icon>add</Icon>&nbsp;Ajouter
                </MDButton>
              </MDBox>
              <MDBox pt={3} px={3} pb={3}>
                <Grid container spacing={3}>
                  {users.map((user) => (
                    <Grid item xs={12} md={6} lg={4} key={user.id}>
                      <Card sx={{ p: 2, border: "1px solid #eee" }}>
                        <MDBox display="flex" justifyContent="space-between" alignItems="center">
                          <MDTypography variant="h6">{user.nom}</MDTypography>
                          <MDBox>
                            <Icon
                              sx={{ cursor: "pointer", mr: 1, color: "info.main" }}
                              onClick={() => handleOpen(user)}
                            >
                              edit
                            </Icon>
                            <Icon
                              sx={{ cursor: "pointer", color: "error.main" }}
                              onClick={() => handleDelete(user.id)}
                            >
                              cancel
                            </Icon>
                          </MDBox>
                        </MDBox>
                        <MDTypography variant="caption" color="text" display="block">
                          Email : {user.email}
                        </MDTypography>
                        <MDTypography variant="caption" color="text" display="block">
                          Ville : {user.ville}
                        </MDTypography>
                        <MDTypography variant="caption" color="text" display="block">
                          Créé le : {new Date(user.created_at).toLocaleDateString("fr-FR")}
                        </MDTypography>
                      </Card>
                    </Grid>
                  ))}
                </Grid>
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>

      <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
        <DialogTitle>{editId ? "Modifier le directeur" : "Ajouter un directeur"}</DialogTitle>
        <DialogContent>
          <MDBox display="flex" flexDirection="column" gap={2} mt={1}>
            <TextField
              label="Nom complet"
              fullWidth
              value={form.nom}
              onChange={(e) => setForm({ ...form, nom: e.target.value })}
            />
            <TextField
              label="Email"
              fullWidth
              type="email"
              value={form.email}
              onChange={(e) => setForm({ ...form, email: e.target.value })}
            />
            <TextField
              label={editId ? "Nouveau mot de passe (laisser vide pour ne pas changer)" : "Mot de passe"}
              fullWidth
              type="password"
              value={form.mot_de_passe}
              onChange={(e) => setForm({ ...form, mot_de_passe: e.target.value })}
            />
            <TextField
              label="Ville"
              fullWidth
              value={form.ville}
              onChange={(e) => setForm({ ...form, ville: e.target.value })}
            />
          </MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton onClick={handleClose} color="secondary">
            Annuler
          </MDButton>
          <MDButton onClick={handleSubmit} color="info" disabled={loading}>
            {loading ? "Enregistrement..." : "Enregistrer"}
          </MDButton>
        </DialogActions>
      </Dialog>
      <Footer />
    </DashboardLayout>
  );
}

export default Utilisateurs;